/**
 * @generated SignedSource<<11640e50546c3d7694b4374589fecdd6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberReportEngagementScoreStatisticCardFragment$data = {
  readonly engagementScoreReport: {
    readonly allTime: number;
    readonly sinceYesterday: number | null;
  };
  readonly " $fragmentType": "MemberReportEngagementScoreStatisticCardFragment";
};
export type MemberReportEngagementScoreStatisticCardFragment$key = {
  readonly " $data"?: MemberReportEngagementScoreStatisticCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberReportEngagementScoreStatisticCardFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDate"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberReportEngagementScoreStatisticCardFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "startDate",
          "variableName": "startDate"
        }
      ],
      "concreteType": "GenericReportingResponse",
      "kind": "LinkedField",
      "name": "engagementScoreReport",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sinceYesterday",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "OrganizationMembership",
  "abstractKey": null
};

(node as any).hash = "d10ebcdf69a83a9a26ac0972ddac095d";

export default node;
